import { GraphObject, Link, Shape } from 'gojs';
import { dataLineageDiagramConfig } from '../../../../../state/data-lineage-diagram';
import { linkStrokeBinding, linkZOrderBinding } from './utils/bindings';
import { mouseHover, mouseLeave } from './utils/events';

const $ = GraphObject.make;

export const defaultLinkTemplate = () =>
  $(
    Link,
    {
      routing: Link.AvoidsNodes,
      curve: Link.JumpOver,
      corner: 15,
      deletable: false,
      selectable: false,
      mouseHover,
      mouseLeave,
    },
    linkShape(),
    linkArrow(),
    linkZOrderBinding(),
  );

const linkShape = () =>
  $(
    Shape,
    {
      strokeWidth: 2,
    },
    linkStrokeBinding(),
  );

const linkArrow = () =>
  $(
    Shape,
    { toArrow: 'OpenTriangle', strokeWidth: 2, stroke: dataLineageDiagramConfig.colors.grey },
    linkStrokeBinding(),
  );
